import React, { useEffect } from 'react';
import { buildOrganizationJsonLd, getPublicSiteOrigin } from 'utils/publicSiteUrl';

const SCRIPT_ID = 'sb-organization-jsonld';

/**
 * Injects Organization structured data once for Google brand/logo discovery.
 */
const OrganizationJsonLd: React.FC = () => {
  useEffect(() => {
    const origin = getPublicSiteOrigin();
    const payload = buildOrganizationJsonLd(origin);
    let script = document.getElementById(SCRIPT_ID) as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement('script');
      script.id = SCRIPT_ID;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(payload);
  }, []);

  return null;
};

export default OrganizationJsonLd;
